import React, { Component } from 'react';
import styled from 'styled-components';

import sideBrandImg from 'images/sideBrand.png';
import redBrandImg from 'images/redBrand.png';
import redBrandUpright from 'images/redBrandUpright.png';
import brandUpright from 'images/brandUpright.png';
import merchImg from 'images/merch.png';

import html2canvas from 'html2canvas';

import FileSaver from 'file-saver';
import IsMobile from 'ismobilejs';

import PreviewArtwork from './PreviewArtwork';
//import UserDetails from './UserDetails';

//const styled = styled.default;

//https://github.com/styled-components/polished/issues/129

function responsiveFontSize({ minFont = 35, maxFont = 60, minScreen = 420, maxScreen = 1440, units = "px" }) {
  return `font-size: calc(${minFont}${units} + ${maxFont - minFont} * (100vw - ${minScreen}${units}) / ${maxScreen - minScreen});
  @media screen and (max-width: ${minScreen}px) {
    font-size: ${minFont}${units};
  }
  @media screen and (min-width: ${maxScreen}px){
    font-size: ${maxFont}${units};
  }
  
  ` 
}

function fluidWidth({ min = 35, max = 60, minScreen = 720, maxScreen = 1440, units = "vw" }) {
  return `width: calc(${min}${units} + ${max - min} * (100vw - ${minScreen}${units}) / ${maxScreen - minScreen});
  @media screen and (max-width: ${minScreen}px) {
    width: ${min}${units};
  }
  @media screen and (min-width: ${maxScreen}px){
    width: ${max}${units};
  }
  
  ` 
}

export const RED = '#E23544';
export const BLACK = 'rgb(34,31,32)';
export const YELLOW = '#F1C734';

export const MOBILE_MAX = '819px';
export const DESKTOP_MIN = '820px';

export const SQUARE_SIZE = '550px';

const MERCH_URL = 'https://store.thirtysecondstomars.com/';

const PREORDER_URL = 'http://smarturl.it/MARSpreorder/';

let namesArray = ['KIM', 'JUSTIN', 'JESUS', 'MICHAEL', 'MICKEY', 'DONALD', 'OKAY WOAH', 'WEIRD', 'MAGIC', 'AMERICA', 'UMMM', 'I CAN TYPE', 'WRITE', 'STUFF', 'HERE', 'DONALD LOL', 'LOL', 'NO RULES?', 'ANYTHING'];

// Create a Wrapper component that'll render a <section> tag with some styles
const Wrapper = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background: ${YELLOW};
  height: 100vh;
  background: ${BLACK};
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  
  color: ${BLACK};
  @media screen and (min-width: ${DESKTOP_MIN}){
    justify-content: space-around;
    background: ${props => props.bgBlack ? BLACK : YELLOW};
    height: 100vh;
    //min-height: calc(${SQUARE_SIZE} + 120)px;
    min-height: 800px;
  }
`;

const Layout = styled.div`
  display: flex;
  position: relative;
  background: #000;
  background: ${props => props.bgBlack ? BLACK : YELLOW};
  width: calc(100vw - 20px);
  max-width: 370px;
  background-size: cover;
  transition: background 0.3s, opacity 0.3s;
  
  pointer-events: ${props => props.fadeOut ? `none` : null};
  &:before {
    content: ' ';
    padding-top: 100%;
    display: block;
    
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    opacity: ${props => props.fadeOut ? 0.5 : null};
    box-shadow: 0 0 2vw rgba(0, 0, 0, 0.1);
    max-width: ${SQUARE_SIZE};
    width: ${SQUARE_SIZE};
    min-height: ${SQUARE_SIZE};
    &:before {
      padding-top: 100%;
      
    }
  }
`;

const SideBrand = styled.div`
  position: absolute;
  top: 7%;
  left: 5%;
  height: 86%;
  width: 50%;
  img {
    height: 100%;
    width: auto;
  }
`;


const LayoutInner = styled.div`
  position: absolute;
  top: 5%;
  left: 20%;
  width: 80%;
  height: 90%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media screen and (min-width: ${DESKTOP_MIN}){
    left: 25%;
    width: 75%;
  }

`;

/*const Title = styled.h1`
  font-family: 'HelveticaNeueLTPro-Md';
  text-align: center;
  color: black;
  ${responsiveFontSize({})}
`;*/



const Header = styled.div`
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  
  font-size: 1.7vw;
  padding: 20px 0;
  
  h2 {
    font-size: 2.7vw;
    letter-spacing: 0.04em;
    font-weight: 300;
    color: #fff;
    margin: 0;
  }
  @media screen and (orientation: landscape) and (max-width: ${MOBILE_MAX}) {
    display: none;
    
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    
    
    h2 {
      font-size: 16px;
      //color: ${BLACK};
    }
  }
`;
const Type = styled.div`
  position: relative;
`;
const TypeInput = styled.input`
  position: relative;
  text-transform: uppercase;
  font-size: 9.9vw;
  /*line-height: 1.22;*/
  color: ${BLACK};
  width: 100%;
  border: 0;
  padding: 0.15em 0 0 0;
  background: none;
  
  @media screen and (min-width: 400px){
    font-size: 38px;
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    font-size: 61px;
  }
  
  &::placeholder {
    color: ${BLACK};
  }
  &::selection {
    background: ${BLACK};
  }
  
  &:focus {
    outline: none;
    //background: #000;
    color: #fff;
  }
`;
const Footer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 6.7vw;
  /*height: 15%;*/
  padding: 1em 0;
  
  a {
    text-transform: uppercase;
    color: #fff;
    text-decoration: none;
    position: relative;
    letter-spacing: 0.04em;
    &:after {
      content: "";
      position: absolute;
      bottom: 2px;
      left: 0;
      height: 2px;
      width: 100%;
      background: #fff;
    }
  }
  .bgColorButton {
    font-size: 4vw;
    margin-top: 20px;
    color: #fff;
    letter-spacing: 0.0em;
    &:after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      height: 2px;
      width: 100%;
      background: #fff;
    }

  }
  @media screen and (min-width: 560px){
    font-size: 27px;
    width: 100%;
    
    
    .bgColorButton {
      display: none;
    }
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    a {
      /*&:hover, &:focus {
        color: ${BLACK};
        outline: none;
        &:after {
          background: ${BLACK};
          background: linear-gradient(left, transparent 0%,${BLACK} 50%,transparent 100%);
        }
      }*/
    }
  }
`;

const LayoutFooter = styled.div`
  position: relative;
  display: flex;
  font-size: 2vw;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  
  margin-top: 3%;
  margin-bottom: auto;
  span {
    text-transform: uppercase;
    text-decoration: none;
    position: relative;
    letter-spacing: 0.04em;
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    margin-top: 2%;
    font-size: 15px;
  }
`;

const ColorPicker = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  
  display: flex;
  flex-direction: row;
  align-items: stretch;
  order: 2;
  flex-basis: 20px;
  z-index: 5;
  @media screen and (orientation: landscape) and (max-width: ${MOBILE_MAX}) {
    margin-top: 20px;
    position: relative;
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    height: 80px;
    position: absolute;
    order: 0;
    z-index: auto;
  }

`;

const ColorSwatch = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  min-height: 16vw;
  cursor: pointer;
  @media screen and (orientation: landscape) and (max-width: ${MOBILE_MAX}) {
    min-height: 40px;
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    min-height: 80px;
  }

`;

const Build = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  /*height: 100%;*/
  height: ${props => props.showFull ? `100%` : null};
  z-index: ${props => props.showFull ? 6 : `auto`};
  background: ${BLACK};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: background 0.3s, transform 0.3s;
  //min-height: 550px
  .changeColorsButton {
    position: relative;
    //bottom: 20px;
    text-transform: uppercase;
    color: #fff;
    text-decoration: none;
    letter-spacing: 0.04em;
    cursor: pointer;
    /*&:after {
      content: "";
      position: absolute;
      bottom: 2px;
      left: 0;
      height: 2px;
      width: 100%;
      background: #fff;
    }*/
    &:hover, &:focus {
      color: #fff;
      outline: none;
      &:after {
        background: #fff;
        
      }
    }

  }
  @media screen and (orientation: landscape) and (max-width: ${MOBILE_MAX}) {
    min-height: 500px;

  }
  @media screen and (max-width: ${MOBILE_MAX}){
    background: ${BLACK} !important;
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    position: absolute;
    height: 100%;
    height: ${props => props.showFull ? `100%` : `calc(100% - 80px)`};
    background: ${props => props.bgBlack ? `rgb(34,31,32) !important` : YELLOW};
    background: ${BLACK} !important;
    min-height: 740px;
    transform: ${props => props.moveUp ? `translate(0, -200px)` : null};
    .changeColorsButton {
      position: absolute;
      bottom: 20px;
      //top: 20px;
      //left: 20px;
      //color: ${BLACK};
      display: block;
      &:after {
        //background: ${BLACK};
      }
    }
  }
`;

const BlackOut = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${BLACK};
`;

const BG = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
`;

const Preview = styled.div`
  position: fixed;
  /*z-index: 2;*/
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${BLACK};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PreviewOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${BLACK};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img.redBrandUpright {
    height: 50px;
    margin-top: 20px;
  }
  img.previewImage {
    width: 90%;
    height: auto;
    box-shadow: 0 0 2vw rgba(0, 0, 0, 0.1);
    max-width: 500px;
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    img.previewImage {
      box-shadow: none;
    }
  }
  @media screen and (orientation: landscape) and (max-width: ${MOBILE_MAX}) {
    img.previewImage {
      max-width: 270px;
    }
  }
  span {
    display: block;
    color: #fff;
    text-decoration: none;
    font-size: 15px;
    margin: 0 0 30px 0;
    display: inline-block;
    position: relative;
    text-transform: uppercase;
  }
  a {
    display: block;
    color: #fff;
    text-decoration: none;
    font-size: 40px;
    margin: 30px 5px 0;
    display: inline-block;
    position: relative;
    &.preorder {
      color: #fff;
    }
    &.finish {
      &:after {
        content: "";
        position: absolute;
        bottom: 2px;
        left: 0;
        height: 2px;
        width: 100%;
        background: #fff;
      }
    }
  }
`;

const MerchLink = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  img {
    width: 20vw;
    max-width: 240px;
  }
`;

const Credit = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: none;
  a {
    text-transform: uppercase;
    font-size: 12px;
    position: relative;
    color: #fff;
    text-decoration: none;
    &:after {
      content: "";
      position: absolute;
      bottom: 1px;
      left: 0;
      height: 1px;
      width: 100%;
      background: #fff;
    }
    &:hover, &:focus {
      color: #ddd;
      outline: none;
      &:after {
        background: #ddd;
        
      }
    }
  }
  @media screen and (min-width: ${DESKTOP_MIN}) {
    display: block;
  }
`;

const FinishMessage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  
  .container {
    width: 60%;
    max-width: 820px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .img {
    width: 100%;
    text-align: center;
    order: 2;
    margin-top: 4vw;
    img {
      width: 40%;
      max-width: 180px;
      height: auto;
    }
  }

  .message {
    width: 100%;
    margin-left: 20px;
  }
  
  
  a {
    font-size: 8.3vw;
  }
  span {
    font-size: 4vw;
    margin-bottom: 1em;
    display: block;
  }
  a {
    text-decoration: none;
    position: relative;
    color: #fff;
    /*display: inline;*/
    overflow-wrap: break-word;
    word-break: break-word;
    word-wrap: break-word;
    box-shadow: inset 0 -2px 0 #fff;
    text-transform: uppercase;
    &:hover, &:focus {
      outline: none;
      color: ${BLACK};
      box-shadow: inset 0 -2px 0 ${BLACK};
      
    }
    &.merch {
      display: inline-block;
      margin-top: 0.8em;
    }
    &.again {
      color: ${BLACK};
      display: inline-block;
      position: relative;
      box-shadow: inset 0 -2px 0 ${BLACK};
      margin-top: 0.8em;
      &:hover, &:focus {
        color: #fff;
        outline: none;
        box-shadow: inset 0 -2px 0 #fff;
      }
    }
  }
  @media screen and (min-width: 520px){
    .container {
      flex-direction: row;
      width: 80%;
    }
    .img {
      order: 0;
      width: 45%;
      margin-top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 100%;
        max-width: 100%;
      }
    }
    span {
      font-size: 20px;
    }
    a {
      font-size: 45px;
    }
  }
  @media screen and (min-width: ${DESKTOP_MIN}){
    .container {
      flex-direction: row;
      width: 100%;
    }
    .img {
      order: 0;
      width: 45%;
      margin-top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 100%;
        max-width: 100%;
      }
    }
    .message {
      width: 100%;
      margin-left: 60px;
    }
    a {
      font-size: 70px;
    }
    span {
      display: block;
      font-size: 20px;
    }
  }

`;


class App extends Component {

  constructor(props) {
    super(props);

    

    this.state = {
      showFinish: false,
      showPreview: false,
      showMerch: false,
      previewCanvas: null,
      showRender: false,
      showUserDetails: false,
      showColorPicker: false,
      bgColor: '#F1C734',
      bgColors: [
        '#F1C734',
        '#9778D3',
        '#2A7DE2',
        '#F93348',
        '#76BD1D',
        '#F377C5'
      ],
      placeholders: {
        word1: '',
        word2: '',
        word3: '',
        word4: '',
        word5: '',
        word6: ''
      },
      words: {
        word1: '',
        word2: '',
        word3: '',
        word4: '',
        word5: '',
        word6: ''
      }
    }
    this.typeIn = this.typeIn.bind(this);
    this.generateArtwork = this.generateArtwork.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleGenerateArtwork = this.handleGenerateArtwork.bind(this);
    this.handleRestart = this.handleRestart.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
    this.handleSubmitUserDetails = this.handleSubmitUserDetails.bind(this);
    this.handleOpenUserDetails = this.handleOpenUserDetails.bind(this);
    this.handleCloseUserDetails = this.handleCloseUserDetails.bind(this);

  }

  

  typeIn(word, obj, delay = 0) {
    var newWord = '';
    var i = 0;

    const typer = () => {
      if(i < word.length){

        newWord += word.charAt(i);
        i++;
        
        this.setState(
          prevState => ({
            placeholders: {
                ...prevState.placeholders,
                [obj]: newWord
            }
          })
        )
        setTimeout(function(){ 
          typer();
        }, 350);

      }
    };
    setInterval(function(){
      typer();
    }, delay);
  }

  componentDidMount(){

    function shuffle(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;
    
      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
    
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
    
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
    
      return array;
    }

    //namesArray = shuffle(namesArray);

   this.typeIn(namesArray[0], 'word1', 500);
   this.typeIn(namesArray[1], 'word2', 700);
   this.typeIn(namesArray[2], 'word3', 900);
   this.typeIn(namesArray[3], 'word4', 1000);
   this.typeIn(namesArray[4], 'word5', 1200);
   this.typeIn(namesArray[5], 'word6', 1400);
   //this.setState()

  }

  handleChange(obj, event) {
    this.setState({
        words: {
            [obj]: event.target.value
        }
    })
  }

  handleRestart(e) {
    e.preventDefault();
    this.setState({
        showPreview: false,
        showMerch: false,
        showFinish: false 
    })
  }

  handleSubmitUserDetails(e) {
    e.preventDefault();
    this.generateArtwork();
    this.setState({
      showUserDetails: false,
    })
  }

  handleOpenUserDetails(e) {
    e.preventDefault();

    this.setState({
      showUserDetails: true,
    })

  }

  handleCloseUserDetails(e) {
    e.preventDefault();
    this.setState({
      showUserDetails: false,
    })
  }

  handleFinish(e) {
    e.preventDefault();
    this.setState({
        showPreview: false,
        showFinish: true,
    })
  }

  generateArtwork(){

    //Get current fields

    this.setState({
      words: {
          word1: document.querySelector("#word1").value !== "" ? document.querySelector("#word1").value : this.state.placeholders.word1,
          word2: document.querySelector("#word2").value !== "" ? document.querySelector("#word2").value : this.state.placeholders.word2,
          word3: document.querySelector("#word3").value !== "" ? document.querySelector("#word3").value : this.state.placeholders.word3,
          word4: document.querySelector("#word4").value !== "" ? document.querySelector("#word4").value : this.state.placeholders.word4,
          word5: document.querySelector("#word5").value !== "" ? document.querySelector("#word5").value : this.state.placeholders.word5,
          word6: document.querySelector("#word6").value !== "" ? document.querySelector("#word6").value : this.state.placeholders.word6
      }
    })

    this.setState({showRender: true});

    setTimeout(function(){ 

      html2canvas(document.querySelector("#preview"), {scale: 2}).then(canvas => {

        this.setState({showRender: false});

        if(IsMobile.any){
          var canvasImage = canvas.toDataURL("image/png");
          this.setState({showPreview: true, previewCanvas: canvasImage });
        } else {
          this.setState({showFinish: true, showMerch: true});
          canvas.toBlob(function(blob) {
            FileSaver.saveAs(blob, "america.png");
          });
        }
        
      });
      
    }.bind(this), 1000);

  }


  handleGenerateArtwork= (e) => {

    e.preventDefault();

    this.generateArtwork();


  }

  handleToggleColorPicker = (e) => {

    e.preventDefault();

    this.setState(prevState => ({ showColorPicker: !prevState.showColorPicker }));

  }

  handleOpenColorPicker = (e) => {

    e.preventDefault();

    this.setState({showColorPicker: true});

  }

  handleCloseColorPicker = (e) => {

    e.preventDefault();

    this.setState({showColorPicker: false});

  }

  /*handleBgColorChange = (e) => {

    e.preventDefault();

    console.log('BG Colour');

    let bgColors = this.state.bgColors;
    let currentBgColor = this.state.bgColor;
    let nextItem = null;

    let index = bgColors.indexOf(currentBgColor);
    if(index >= 0 && index < bgColors.length - 1){
      nextItem = bgColors[index + 1];
    } else {
      nextItem = bgColors[0];
    }

    this.setState({bgColor: nextItem, showColorPicker: true});


  }*/


  render() {
    let previewOverlay = null;
    if(this.state.showPreview) {
      previewOverlay = <PreviewOverlay id="previewOverlay"><span>TOUCH + HOLD THE IMAGE TO SAVE IT</span><img src={this.state.previewCanvas} className='previewImage' alt=''/><a href="" role="button" className="finish" onClick={ this.handleFinish }>I GOT IT</a></PreviewOverlay>
    }
    
    return (
      <div>
      <Wrapper id="wrapper" bgBlack={this.state.showPreview}>
        { this.state.showRender ?
          <Preview >
            <div id="preview">
              <PreviewArtwork words={this.state.words} placeholders={this.state.placeholders} bgColor={this.state.bgColor} />
              </div>
          </Preview>
          : null
        }

        <BlackOut />
        { this.state.showPreview || this.state.showFinish ?
        null
        : 
        <ColorPicker id="colorPicker">
          { this.state.bgColors.map((color, i) => {
            return <ColorSwatch style={{background: color}} onClick={(e)=> { this.setState({bgColor: color}); }} key={i} ></ColorSwatch>
          })}
        </ColorPicker>
        }
        
        <Build id="build" bgBlack={this.state.showPreview} style={{background: this.state.bgColor}} moveUp={this.state.showColorPicker} showFull={this.state.showFinish || this.state.showPreview} >
          <BG />
          <Credit><a href="http://designedmemory.com" target="_blank" rel="noopener noreferrer">A Web Thing by designedmemory</a></Credit>
          <Header>
            <h2>MAKE YOUR OWN COVER. CLICK A WORD. TYPE IT.</h2>
          </Header>
          <Layout id="layout" bgBlack={this.state.showPreview} style={{background: this.state.bgColor}} fadeOut={this.state.showColorPicker}>
            
            <SideBrand>
              <img src={sideBrandImg} alt='' />
            </SideBrand>
            { this.state.showFinish ?
              null
            : 
              <LayoutInner>
              
                
                <Type>
                  <TypeInput id="word1" type='text' placeholder={this.state.placeholders.word1} maxLength="10" autoFocus ></TypeInput>
                  <TypeInput id="word2" type='text' placeholder={this.state.placeholders.word2} maxLength="10"></TypeInput>
                  <TypeInput id="word3" type='text' placeholder={this.state.placeholders.word3} maxLength="10"></TypeInput>
                  <TypeInput id="word4" type='text' placeholder={this.state.placeholders.word4} maxLength="10"></TypeInput>
                  <TypeInput id="word5" type='text' placeholder={this.state.placeholders.word5} maxLength="10"></TypeInput>
                  <TypeInput id="word6" type='text' placeholder={this.state.placeholders.word6} maxLength="10"></TypeInput>
                </Type>

                <LayoutFooter><span>THIS IS MY AMERICA</span></LayoutFooter>
                

              </LayoutInner>
            }
          </Layout>
          <Footer>
            <a href="" role="button" onClick={ this.handleGenerateArtwork }>I'M FINISHED</a>
            
          </Footer>
          <div className="changeColorsButton" >Change Color</div>
          {previewOverlay}
          { this.state.showFinish ?
              <FinishMessage style={{background: this.state.bgColor}}>
                <div className="container">
                  <div className="img">
                    <img src={brandUpright} alt=''/>
                  </div>
                  <div className="message">
                    <span>CLICK BELOW TO:</span>
                    <a href={PREORDER_URL} className="preorder" target="_blank">PRE-ORDER <br/>“AMERICA”</a><br/>
                    <a href={MERCH_URL} className="merch" target='_blank'>Wear Mars</a>
                    <a href="" role="button" className="again" onClick={ this.handleRestart } >DO IT AGAIN</a>
                  </div>
                </div>
              </FinishMessage>
            : null
            }
          </Build>
        
        
        { this.state.showUserDetails ?
        {/*<UserDetails saveUsers={this.handleSubmitUserDetails} closeUsers={this.handleCloseUserDetails}/>*/}
        : null }
      </Wrapper>
      </div>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js